"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaIcon = _interopRequireWildcard(require("@thinkific/toga-icon"));

var _togaLabel = _interopRequireDefault(require("@thinkific/toga-label"));

var _Input = _interopRequireDefault(require("./Input.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Input["default"]);

var Input = /*#__PURE__*/function (_Component) {
  _inherits(Input, _Component);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleValueFieldChange", function (e) {
      var _this$props = _this.props,
          handleChange = _this$props.handleChange,
          validator = _this$props.validator;
      var newValue = e.target.value;
      var isValid = true;

      if (validator && !validator(newValue)) {
        isValid = false;
      }

      if (isValid) {
        _this.setState({
          value: newValue
        });

        if (handleChange) handleChange(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "sanitizeState", function (state) {
      var sanitizedState = {};
      Object.keys(state).forEach(function (key) {
        sanitizedState[key] = state[key].trim();
      });
      return sanitizedState;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var handleBlur = _this.props.handleBlur;
      handleBlur(e, _this.sanitizeState(_this.state));
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var handleKeyDown = _this.props.handleKeyDown;
      handleKeyDown(e, _this.sanitizeState(_this.state));
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      var onEnter = _this.props.onEnter;

      if (e.key === 'Enter' && onEnter !== null) {
        onEnter(e, _this.sanitizeState(_this.state));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resetInputValue", function () {
      _this.setState({
        value: ''
      });

      var _this$props2 = _this.props,
          handleChange = _this$props2.handleChange,
          name = _this$props2.name;
      if (handleChange) handleChange({
        target: {
          value: '',
          name: name
        }
      });
    });

    _this.state = {
      value: ''
    };
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(Input, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var initValue = this.props.initValue;

      if (initValue !== '') {
        this.setState({
          value: initValue.toString()
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoFocus = this.props.autoFocus;

      if (autoFocus) {
        this.input.select();
      }
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Update the input state when you change the value from outside
      this.setState({
        value: nextProps.initValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          name = _this$props3.name,
          type = _this$props3.type,
          placeholder = _this$props3.placeholder,
          maxLength = _this$props3.maxLength,
          extraClasses = _this$props3.extraClasses,
          extraProps = _this$props3.extraProps,
          label = _this$props3.label,
          leftAccessory = _this$props3.leftAccessory,
          rightAccessory = _this$props3.rightAccessory,
          autoFocus = _this$props3.autoFocus,
          hasError = _this$props3.hasError,
          hasNoGroup = _this$props3.hasNoGroup,
          icon = _this$props3.icon,
          hasClearButton = _this$props3.hasClearButton,
          wrapperClass = _this$props3.wrapperClass,
          formText = _this$props3.formText;
      var value = this.state.value;
      var hasLabel = !!label;
      var inputLabel = label;

      if (typeof label === 'string') {
        inputLabel = /*#__PURE__*/_react["default"].createElement(_togaLabel["default"], {
          className: cx('label', 'input__label'),
          htmlFor: id
        }, label);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('input__box', wrapperClass, {
          'form-group': !hasNoGroup
        })
      }, inputLabel, leftAccessory && /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('left-acessory__box')
      }, leftAccessory), icon && /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
        className: cx('input__box__icon--left', {
          'label-spacing': hasLabel
        }),
        name: icon,
        "aria-hidden": true
      }), /*#__PURE__*/_react["default"].createElement("input", _extends({
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        className: cx('input__box--input', 'form-control', extraClasses, {
          'has-left-accessory': !!leftAccessory,
          'has-right-accessory': !!rightAccessory,
          'has-icon': icon,
          'has-error': hasError
        }),
        id: id,
        maxLength: maxLength,
        name: name,
        placeholder: placeholder,
        ref: function ref(node) {
          _this2.input = node;
          return _this2.input;
        },
        type: type // eslint-disable-line jsx-a11y/no-autofocus
        ,
        value: value // eslint-disable-line no-return-assign
        ,
        onBlur: this.handleBlur,
        onChange: this.handleValueFieldChange,
        onKeyDown: this.handleKeyDown,
        onKeyPress: this.handleKeyPress
      }, extraProps)), rightAccessory && /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('right-acessory__box')
      }, rightAccessory), hasClearButton && value && /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
        className: cx('input__box__icon--right', {
          'label-spacing': hasLabel
        }),
        name: "circle-fill-x",
        role: "button",
        title: "Clear input",
        onClick: this.resetInputValue
      }), formText && /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('form-text', {
          'has-error': hasError
        })
      }, formText));
    }
  }]);

  return Input;
}(_react.Component);

Input.propTypes = {
  // TODO: replace to hasAutoFocus
  autoFocus: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming
  extraClasses: _propTypes["default"].string,
  extraProps: _propTypes["default"].object,
  formText: _propTypes["default"].string,
  handleBlur: _propTypes["default"].func,
  handleChange: _propTypes["default"].func,
  handleKeyDown: _propTypes["default"].func,
  hasClearButton: _propTypes["default"].bool,
  hasError: _propTypes["default"].bool,
  hasNoGroup: _propTypes["default"].bool,
  icon: _propTypes["default"].oneOf(_togaIcon.availableIcons),
  id: _propTypes["default"].string,
  initValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  label: _propTypes["default"].any,
  leftAccessory: _propTypes["default"].element,
  maxLength: _propTypes["default"].number,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  rightAccessory: _propTypes["default"].element,
  type: _propTypes["default"].string,
  validator: _propTypes["default"].func,
  wrapperClass: _propTypes["default"].string,
  onEnter: _propTypes["default"].func
};
Input.defaultProps = {
  autoFocus: false,
  handleBlur: function handleBlur() {},
  handleKeyDown: function handleKeyDown() {},
  validator: function validator() {
    return true;
  },
  handleChange: null,
  hasClearButton: false,
  hasError: false,
  name: '',
  type: 'text',
  initValue: '',
  placeholder: '',
  extraProps: {},
  extraClasses: '',
  maxLength: null,
  label: null,
  id: null,
  icon: null,
  leftAccessory: null,
  rightAccessory: null,
  onEnter: null,
  hasNoGroup: false,
  wrapperClass: null,
  formText: null
};
var _default = Input;
exports["default"] = _default;